<template lang="pug">
  #contract-chat-confirm-data
    h4.mx-2.mt-1.mb-4.text-center.border.message-border-style.border-success.rounded.p-3 送信前に入力内容をご確認ください。
    b-container(fluid="fluid")
    b-row
      b-col
        h5(:class="chat_service_title_class") ビジネスチャット ChatLuck（1ユーザー￥330/月）
          b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractChatOrder', hash: '#chat-user', params: { service_type: 'chat'}}") 修正
        b-form-text(:class="chat_service_data_class") {{value.chat_user}} ユーザー
        b-form-text(style="height: 30px;")
        template(v-if="value.option")
          h5(:class="chat_service_title_class") オプションサービス
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractChatOrder', hash: '#chat-option-service', params: { service_type: 'chat', anchor: 'chat_option_service'}}") 修正
          template(v-if="value.option.disk")
            b-form-text(:class="chat_service_data_class") ディスク増設（20GBあたり￥1,100/月）
              b-row
                b-col(cols="1")
                b-col
                  b-form-text.text-left 20GB × {{value.option.disk.disk_size}} = {{20 * value.option.disk.disk_size}} GB増設
          b-form-text(style="height: 30px;")
        template(v-if="value.security")
          h5(:class="chat_service_title_class") セキュリティオプション
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractChatOrder', hash: '#chat-security-option', params: { service_type: 'chat', anchor: 'chat_security_option'}}") 修正
          template(v-if="value.security.basic")
            b-form-text(:class="chat_service_data_class") BASIC認証 (無償)
              b-row
                b-col(cols="1")
                b-col
                  b-form-text.text-left ユーザーID ： {{value.security.basic.basic_id}}
                  basic-password(form_name="パスワード", :password="value.security.basic.basic_password")
                  b-form-text.text-left 認証を除外するIPアドレス：
                  b-form-text.text-left.ml-1(v-for="(ip_addr) of basic_except_ip") {{ip_addr}}
          template(v-if="value.security.connect_permit_ip")
            b-form-text(:class="chat_service_data_class") 接続元IPアドレス制限 (無償)
              b-row
                b-col(cols="1")
                b-col
                  b-form-text.text-left 接続を許可するIPアドレス：
                  b-form-text.text-left.ml-1(v-for="(ip_addr) of connect_permit_ip") {{ip_addr}}
          b-form-text(style="height: 30px;")
        h5(:class="chat_service_title_class") ご希望サブドメイン名
          b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractChatOrder', hash: '#chat-sub-domain', params: { service_type: 'chat'}}") 修正
        b-form-text(:class="chat_service_data_class") {{value.sub_domain}}.chatluck.net
        b-form-text(style="height: 30px;")
        template(v-if="value.migration")
          h5(:class="chat_service_title_class") 無料お試し版からのデータ移行
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractChatOrder', hash: '#chat-migration', params: { service_type: 'chat', anchor: 'chat_migration'}}") 修正
          b-form-text(:class="chat_option_data_class") 希望する
          b-form-text(:class="chat_no_border") 試使用環境URL ： {{value.migration.url}}
          b-form-text.pb-2(:class="chat_no_border_top") 作業日時 ： {{migration_date}}
        template(v-else)
          h5(:class="chat_service_title_class") ご利用開始希望日
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractChatOrder', hash: '#preferred-date', params: { service_type: 'chat', anchor: 'preferred_date'}}") 修正
          b-form-text(:class="chat_service_data_class") {{preferred_date}}
        b-form-text(style="height: 30px;")
        template(v-if="value.estimate")
          h5(:class="chat_service_title_class") お見積番号
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractChatOrder', hash: '#chat-estimate', params: { service_type: 'chat', anchor: 'chat_migration_url'}}") 修正
          b-form-text.pb-2(v-html="estimate" :class="chat_service_data_class")
          b-form-text(style="height: 30px;")
        template(v-if="value.remarks !== ''")
          h5(:class="chat_service_title_class") 備考
            b-button.anchor-button.ml-2(size="sm", :to="{name: 'ContractChatOrder', hash: '#chat-remarks', params: { service_type: 'chat'}}") 修正
          b-form-text.pb-2.white-space(:class="chat_service_data_class") {{value.remarks}}
          b-form-text(style="height: 30px;")

        payment-detail-list(:register_data="payment_detail", :show_notice="{plan: false, neo: false, chat: true}", :contract_type="contract_type")
</template>

<script>
import PaymentDetailList from "@/components/PaymentDetailList"
import BasicPassword from '@/components/BasicPassword';

export default {
  name: "ContractChatConfirmData",
  components: {
    PaymentDetailList,
    BasicPassword
  },
  props: {
    value: { type: Object, required: false },
    contract_type: { type: Number, required: false, Default:0},  // ご契約種別(0:月払い、1:年間一括払い)
  },
  data() {
    return {
      chat_service_title_class: "font-weight-bold ml-3 border-top border-bottom py-2 chat-title-bg-color",
      chat_service_data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom border-success label-font-size",
      chat_option_data_class: "ml-3 pt-2 px-2 mb-0 border-top border-success label-font-size",
      chat_option_data_last_class: "ml-3 pt-2 px-2 mb-2 border-top border-bottom border-success label-font-size",
      chat_no_border: "ml-3 pt-2 px-2 mb-2 border-success label-font-size",
      chat_no_border_top: "ml-3 pt-2 px-2 mb-2 border-bottom border-success label-font-size",
    }
  },
  computed: {
    basic_except_ip() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.value.security.basic.basic_except_ip, 5, '\n')
    },
    connect_permit_ip() {
      // 半角区切りをカンマ区切りにして5つ毎に改行する
      return this.showItemsAsRow(this.value.security.connect_permit_ip, 5, '\n')
    },
    estimate() {
      // 見積番号を1つずつ改行して表示する
      return 'No : <br>' + this.value.estimate.replaceAll(/\r?\n/g, '<br>')
    },
    preferred_date() {
      // 2021年12月2日(木) のような形式にする
      return this.showDateString(this.value.preferred_date)
    },
    migration_date() {
      // 2021年12月2日(木) 11:00 - 12:00 のような形式にする
      return this.showDateString(this.value.migration.date, this.value.migration.time_from, this.value.migration.time_to)
    },
    // ご注文明細に渡す変数
    payment_detail() {
      // 変数の初期化
      let params = {'chat': {}}

      Object.keys(this.value).forEach((key) => {
        // お見積番号の場合
        if (key === 'estimate') {
          // そのまま渡す
          params[key] = this.value[key]
        }
        // 上記以外の場合
        else {
          // chatの中に入れて渡す
          params.chat[key] = this.value[key]
        }
      })

      // 作成した変数を返す
      return params
    }
  }
}
</script>

<style scoped>
.message-border-style {
  border-width: 2px !important;
}
.title-bg-color {
  background-color: #f2ffff;
}
.chat-title-bg-color {
  background-color: #f0ffe0;
}
.customer-title-bg-color {
  background-color: #f5f5f5;
}
.label-font-size {
  font-size: 16px;
}
.anchor-button {
  height: 22px;
  vertical-align: center;
  text-align: center;
  margin-top: -2px;
  padding-top: 0;
}
.white-space {
  white-space: pre-wrap;
}
</style>
